<!--Archive-->
<ui-confirmation-dialog
    #confirmArchiveDialog
    header="applicant-tracker.confirmAction"
    primaryButtonLabel="applicant-tracker.archive"
    secondaryButtonLabel="cancel"
>
    {{ 'applicant-tracker.areYouSureYouWantToArchiveThisJob' | translate }}
</ui-confirmation-dialog>

<ui-dialog
    size="small"
    [open]="isOpenPauseModal"
    header="applicant-tracker.confirmAction"
    (closing)="closePauseModal()"
>
    <p>{{ 'applicant-tracker.areYouSureYouWantToPauseThisJobPosting' | appTranslate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closePauseModal()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button type="primary" (click)="onPause()">{{ 'applicant-tracker.pause' | appTranslate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<app-header
    *ngIf="jobPosting"
    [title]="jobPosting.title"
    [menuService]="jobPostingMenuService"
    [back]="true"
    backRoute="/recruiting/jobPostings"
    [contextMenu]="canArchive"
    contextMenuType="material"
>
    <button mat-menu-item *ngIf="!jobPosting.archivedAt" (click)="onArchive()">
        {{ 'applicant-tracker.archive' | translate }}
    </button>
    <button mat-menu-item *ngIf="jobPosting.archivedAt" (click)="onUnarchive()">
        {{ 'applicant-tracker.unarchive' | translate }}
    </button>
    <ng-container>
        <button mat-menu-item *ngIf="!jobPosting.pausedAt && !jobPosting.archivedAt" (click)="openPauseModal()">
            {{ 'applicant-tracker.pause' | translate }}
        </button>
        <button mat-menu-item *ngIf="jobPosting.pausedAt && !jobPosting.archivedAt" (click)="onUnpause()">
            {{ 'applicant-tracker.unpause' | translate }}
        </button>
    </ng-container>
    <button mat-menu-item (click)="copyPosting()">{{ 'duplicate' | translate }}</button>

    <div class="buttons">
        <ng-content select=".buttons"></ng-content>
        <ui-button
            *ngIf="showApplicantMessagingButton"
            type="primary"
            [url]="'/recruiting/bulk-applicant-message/' + jobPosting.id"
            >{{ 'applicant-tracker.emailApplicants' | appTranslate }}
        </ui-button>
    </div>
</app-header>
